import { Injectable } from '@angular/core';
import { KeycloakService } from 'keycloak-angular';

@Injectable()
export class AuthenticationService {
  constructor(private keycloakService: KeycloakService) {}
  keycloakInstance = this.keycloakService.getKeycloakInstance();

  getRoles(): any {
    if (this.keycloakInstance) {
      return this.keycloakInstance?.tokenParsed &&
        this.keycloakInstance?.tokenParsed['role_name']
        ? this.keycloakInstance.tokenParsed['role_name']
        : [];
    } else {
      return [];
    }
  }
  getCompanyId(): string {
    if (this.keycloakInstance) {
      const companyId =
        this.keycloakInstance.tokenParsed?.['company_id'] ?? 'No Company ID';
      return companyId;
    } else {
      return '';
    }
  }

  getBranchId(): string {
    if (this.keycloakInstance) {
      const branchId =
        this.keycloakInstance.tokenParsed?.['branch_id'] ?? 'No Company ID';
      return branchId;
    } else {
      return '';
    }
  }

  getBranchName(): string {
    if (this.keycloakInstance) {
      const branchName =
        this.keycloakInstance.tokenParsed?.['branch_name'] ?? 'No Branch Name';
      return branchName;
    } else {
      return '';
    }
  }

  getRouteId(): string {
    if (this.keycloakInstance) {
      const routeId =
        this.keycloakInstance.tokenParsed?.['route_id'] ?? 'No Route ID';
      return routeId;
    } else {
      return '';
    }
  }

  getRoleId(): string {
    if (this.keycloakInstance) {
      const roleId =
        this.keycloakInstance.tokenParsed?.['role_id'] ?? 'No Role ID';
      return roleId;
    } else {
      return '';
    }
  }
  getRoleName(): string {
    if (this.keycloakInstance) {
      const roleName =
        this.keycloakInstance.tokenParsed?.['role_name'] ?? 'No role name';
      return roleName;
    } else {
      return '';
    }
  }

  getBranchType(): string {
    if (this.keycloakInstance) {
      const branchType =
        this.keycloakInstance.tokenParsed?.['branch_type'] ?? 'No Company ID';
      return branchType;
    } else {
      return '';
    }
  }

  getUserId(): string {
    if (this.keycloakInstance) {
      const userId =
        this.keycloakInstance.tokenParsed?.['user_id'] ?? 'No User ID';
      return userId;
    } else {
      return '';
    }
  }

  logout(): void {
    sessionStorage.clear();
    localStorage.clear();
    this.keycloakInstance.logout({
      redirectUri: window.location.origin,
    });
  }
}
